import React from "react";
import { Box, Paper, Typography, Stack } from "@mui/material";

// Центрована картка авторизації з брендом — спільна для Login/Register.
export default function AuthShell({ title, subtitle, children, maxWidth = 430 }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, py: { xs: 2, md: 5 } }}>
      <Paper elevation={1} sx={{ p: { xs: 3, md: 4 }, width: "100%", maxWidth }}>
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 2.5 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: "10px", flexShrink: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "linear-gradient(135deg, #6c1129 0%, #47091b 100%)",
            color: "#fff", fontWeight: 800, fontSize: 20, lineHeight: 1,
            boxShadow: "0 3px 10px rgba(108,17,41,0.4)",
          }}>a</Box>
          <Typography sx={{ fontWeight: 800, fontSize: 20, letterSpacing: "-0.01em" }}>
            appoint<Box component="span" sx={{ color: "primary.main" }}>Me</Box>
          </Typography>
        </Stack>

        <Typography variant="h5" sx={{ mb: subtitle ? 0.5 : 2.5 }}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>{subtitle}</Typography>
        )}
        {children}
      </Paper>
    </Box>
  );
}
